import type { CSSProperties } from "react";

import type { AnalyticsElementId } from "@/lib/analytics/analyticsElementId";
import { cn } from "@/lib/utils";
import type { ArticleDefinition } from "../articleRegistry";
import { ArticleCard } from "./ArticleCard";

import "../blog.css";

/** Widest row the three-column design draws; a shorter list is capped to its own share of it. */
const MAX_COLUMNS = 3;

type ArticleGridProps = {
  articles: readonly ArticleDefinition[];
  baseAnalyticsElementId: AnalyticsElementId;
  className?: string;
};

export function ArticleGrid({ articles, baseAnalyticsElementId, className }: ArticleGridProps) {
  return (
    <div
      className={cn("blog-article-grid", className)}
      style={{ "--blog-article-columns": Math.min(articles.length, MAX_COLUMNS) } as CSSProperties}
    >
      {articles.map((article) => (
        <ArticleCard key={article.slug} article={article} baseAnalyticsElementId={baseAnalyticsElementId} />
      ))}
    </div>
  );
}
